import { NgModule } from '@angular/core';
import { AsyncPipe, DatePipe, SlicePipe } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';

import { MatIcon } from '@angular/material/icon';
import { MatRipple } from '@angular/material/core';
import { MatInput } from '@angular/material/input';
import { MatMenu, MatMenuItem, MatMenuTrigger } from '@angular/material/menu';
import { MatFormField, MatSuffix } from '@angular/material/form-field';
import {
  CdkFixedSizeVirtualScroll,
  CdkVirtualScrollViewport,
} from '@angular/cdk/scrolling';

import { TranslateModule } from '@ngx-translate/core';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { GetNamePipe } from '../../shared/pipes/get-name.pipe';
import { SafeUrlPipe } from '../../shared/pipes/safe-url.pipe';

import { SwiperDirective } from '../../shared/directives/swiper.directive';

import { UserAccountRoutingModule } from './user-account-routing.module';

import { UserAccountComponent } from './user-account.component';
import { UserTripsComponent } from './user-trips/user-trips.component';
import { UserSettingsComponent } from './user-settings/user-settings.component';
import { SwitcherComponent } from '../../shared/components/switcher/switcher.component';
import { PreviewMapComponent } from '../../shared/maps/preview-map/preview-map.component';
import { ShortTripInfoComponent } from './user-trips/short-trip-info/short-trip-info.component';
import { HeaderBannerComponent } from '../../shared/components/header-banner/header-banner.component';
import { TripPlanPrintComponent } from '../../shared/components/trip-plan-print/trip-plan-print.component';
import { StartPlaningMobileComponent } from '../../shared/components/start-planing-mobile/start-planing-mobile.component';

@NgModule({
  declarations: [
    UserAccountComponent,
    UserSettingsComponent,
    UserTripsComponent,
    ShortTripInfoComponent,
  ],
  imports: [
    UserAccountRoutingModule,
    NgxSkeletonLoaderModule,
    PreviewMapComponent,
    TranslateModule,
    GetNamePipe,
    TripPlanPrintComponent,
    ReactiveFormsModule,
    AsyncPipe,
    SwitcherComponent,
    StartPlaningMobileComponent,
    MatIcon,
    MatRipple,
    MatMenu,
    MatMenuItem,
    MatMenuTrigger,
    SwiperDirective,
    HeaderBannerComponent,
    MatFormField,
    MatInput,
    MatSuffix,
    CdkFixedSizeVirtualScroll,
    CdkVirtualScrollViewport,
    SafeUrlPipe,
    SlicePipe,
    DatePipe,
  ],
})
export class UserAccountModule {}
